import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Missing reset token — please use the link from your email"); return; }
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset — please sign in with your new password");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Reset failed — the link may have expired");
    } finally { setBusy(false); }
  };

  return (
    <div className="container-luxe section-pad max-w-md" data-testid="reset-page">
      <p className="overline">New password</p>
      <h1 className="font-display text-4xl md:text-5xl text-aubergine leading-[1.1] mt-3">Set a new password</h1>
      <p className="mt-3 text-plumSoft leading-relaxed">Choose a password you&rsquo;ll remember — at least 6 characters.</p>

      {!token && (
        <div className="mt-6 rounded-xl bg-rose/10 border border-rose/25 p-4">
          <p className="text-sm text-rose">This reset link is missing its token. Please open the link from your email again, or <Link to="/forgot-password" className="text-plum">request a new one</Link>.</p>
        </div>
      )}

      <form onSubmit={submit} className="mt-8 card-luxe p-8 space-y-5">
        <div>
          <label className="label-luxe">New password</label>
          <input data-testid="rp-password" required type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="input-luxe" placeholder="At least 6 characters" />
        </div>
        <div>
          <label className="label-luxe">Confirm password</label>
          <input data-testid="rp-password2" required type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="input-luxe" />
        </div>
        <button data-testid="rp-submit" disabled={busy || !token} className="btn-primary w-full">{busy ? "Saving…" : "Update password"}</button>
      </form>

      <p className="text-sm text-plumSoft mt-6 text-center font-light">
        <Link to="/login" className="text-plum">Back to sign in</Link>
      </p>
    </div>
  );
}
